import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import {
  IPagedResults,
  PagedResults,
} from '@app/infrastructure/models/response';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { ITableColumns, ITableConfig, TableConfig } from '@models/table';

@Component({
  selector: 'app-table',
  styleUrls: ['./table.component.scss'],
  templateUrl: './table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent {
  @Input() public columnIdList: string[] = [];
  @Input() public displayedColumns: ITableColumns[] = [];
  @Input() public tableData: IPagedResults<any> = new PagedResults<any>();
  @Input() public tableConfig: ITableConfig = new TableConfig();

  @Output() public emitDelete = new EventEmitter<any>();
  @Output() public emitPageUpdate: EventEmitter<PageEvent> =
    new EventEmitter<PageEvent>();

  public emit(item: any, emitName: string): void {
    this[emitName].emit(item);
  }

  public pageUpdate(pageEvent: PageEvent): void {
    this.emitPageUpdate.emit(pageEvent);
  }

  /** Using `*ngIf` destroys the `ViewChild` references */
  public showGrid(): string {
    return !!this.tableData && !!this.tableData.results.length
      ? 'inherit'
      : 'none';
  }

  public getStyleByCol(colA: ITableColumns, val: any): any {
    const found = this.tableConfig.columnStyles.find(
      (colB) => colB.columnId.toLowerCase() === colA.columnId.toLowerCase(),
    );

    // Run style procedure if defined
    if (found?.proc) found.style = found.proc(colA, val);

    return found ? found.style : {};
  }

  public joinPaths(path = '', id = '', action = ''): string {
    return [path, id, action].filter((item) => item !== '').join('/');
  }
}
